var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.75C5 7.34375 5.3125 7 5.75 7H18.25C18.6562 7 19 7.34375 19 7.75C19 8.1875 18.6562 8.5 18.25 8.5H5.75C5.3125 8.5 5 8.1875 5 7.75ZM5 12.75C5 12.3438 5.3125 12 5.75 12H18.25C18.6562 12 19 12.3438 19 12.75C19 13.1875 18.6562 13.5 18.25 13.5H5.75C5.3125 13.5 5 13.1875 5 12.75ZM18.25 18.5H5.75C5.3125 18.5 5 18.1875 5 17.75C5 17.3438 5.3125 17 5.75 17H18.25C18.6562 17 19 17.3438 19 17.75C19 18.1875 18.6562 18.5 18.25 18.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.83a132a6101f64490aec52e014d542ce.svg";
export { ForwardRef as ReactComponent };